import { render, staticRenderFns } from "./AnswerCaseStudy.vue?vue&type=template&id=15cadf96"
import script from "./AnswerCaseStudy.vue?vue&type=script&lang=js"
export * from "./AnswerCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./AnswerCaseStudy.vue?vue&type=style&index=0&id=15cadf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports